export default __webpack_public_path__ + "220060df478c84a8982656792d3fbe50.svg";